export const EXSBWAREHOUSE_DELETE_RESET = 'EXSBWAREHOUSE_DELETE_RESET'
export const EXSBWAREHOUSE_DELETE_SET_ERROR = 'EXSBWAREHOUSE_DELETE_SET_ERROR'
export const EXSBWAREHOUSE_DELETE_SET_DELETED = 'EXSBWAREHOUSE_DELETE_SET_DELETED'
export const EXSBWAREHOUSE_DELETE_TOGGLE_LOADING = 'EXSBWAREHOUSE_DELETE_TOGGLE_LOADING'
